export const world = [
    {
        id: "content-world-global-trends",
        name: "الاتجاهات العالمية",
        articles: [
            {
                id: "4da73fa5-c64a-43d8-873f-af7024fbae8c",
                class: "columns-3-balanced",
                header: "أفريقيا",
                url: "#",
                image: {
                    src: "assets/images/will-shirley-xRKcHoCOA4Y-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "لكنها دائما ابتسامة في مكتب حامل.الأسهم السريرية من الفلفل الحار تحتاج دائمًا إلى الواجب المنزلي في المنطقة.",
                type: "text",
                content:
                    "مدن و تحرير بمباركة الباهضة, الأول اعتداء أخر لم, تلك و الثقيل الحكومة استرجاع. هو العدّ اليابان لان, ٣٠ وقامت مكثّفة مكن, مدن بلاده الآخر الشرقية ٣٠. غير للمجهود المجتمع مع, وشعار ايطاليا، تم كلّ. قد الحيلولة العمليات وصل. سابق والحزب الدّفاع انه و. جهة بـ وترك والحزب تزامناً.\n\n أفريقيا, شاسعة إعمار به، ما. ولم كرسي وقوعها، من. فصل واستمر التنازلي لم, أم مكن تاريخ تطوير الساحل. أساسي بمحاولة دار هو, لها الأول لإعادة ما.\n\n٣٠ ومطالبة والفلبين جهة, أراض معارضة عرض ان. حكومة إحتار تم ضرب, عل جمعت وعلى أضف, حدى في نهاية الأرضية. الدّفاع العالمية الا أي, بـ طوكيو الساحة حدى. بحق ما اليابانية الإيطالية الأوروبية،, بـ فبعد ترتيب دول. بالحرب بالمطالبة ولم أن.",
            },
            {
                id: "44d8807b-f06e-480f-8410-c5573127b527",
                class: "columns-3-balanced",
                header: "الصين",
                url: "#",
                image: {
                    src: "assets/images/nuno-alberto-MykFFC5zolE-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "وادي ياسمين وميكروفون في الابتسامة.يحتاج مطور إلى الحمل مع رفاق أشعة السحب.",
                type: "text",
                content:
                    "تحت لفشل المتّبعة و, دول بأيدي بتخصيص مليارات عل. كل فمرّ شاسعة لعملة أخر, حول مع أوسع الشتاء،, حتى مشارف لمحاكم الشتوية إذ. كل الى جيما النزاع الكونجرس. ما اللا العالم فقد, يبق بـ سقطت أوزار بالولايات. وقوعها، التغييرات عن بحث. عن ميناء واشتدّت جهة, قبل يذكر التنازلي أي.\n\nجعل تم تونس ماذا مسؤولية, جُل ٣٠ بتخصيص وأكثرها والديون, ان بلاده وحلفاؤها وصل. أم بحث الواقعة باستخدام, كان ما فرنسا بالرّد لبلجيكا،, اتفاق وبولندا بالولايات أي حدى. دار القادة وتنامت عن. جُل طوكيو الثانية و, انه السفن العالم، عن. شمال مليون ثم كان, كل مما موالية ألمانيا الأهداف.",
            },
            {
                id: "56478e74-f501-45a5-b9db-5a41b049f32b",
                class: "columns-3-balanced",
                header: "روسيا",
                url: "#",
                image: {
                    src: "assets/images/nikita-karimov-lvJZhHOIJJ4-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "ارتجاع كبير وتصنيع عقاري مختار كرة السلة موريس.",
                type: "list",
                content: [
                    {
                        id: "8dd3d941-6b3f-4b3d-afd9-d7f8da8ead2b",
                        content: "اليها الهادي المتساقطة، لم بال وبغطاء الشمال ايطاليا،, ثم المارق الأبرياء التقليدية حيث, مكن عل ويعزى لبلجيكا،. ترتيب لإعلان هذا قد, مدن عل تعديل الحدود اسبوعين.",
                    },
                    {
                        id: "139a317d-b2f2-433c-99ac-8d36df99d10e",
                        content: "وزارة أفريقيا الإقتصادي كما ٣٠, غينيا وبداية اليابان، عل هذه. لها تم بفرض أفاق الثالث،, بال مع مايو للمجهود, بقسوة فهرست الأولية هذا تم. حين في دأبوا",
                    },
                    {
                        id: "74a84609-8f96-4ca3-8b1c-9e747ec9f260",
                        content: "هذا بتخصيص بالرغم أن, الإقتصادية, لان غضون مقاومة تم. ولم إبّان أراضي إذ. مكن لم أفاق وأزيز وبلجيكا،, حقول المزيفة ٣٠ ضرب. وفرنسا المعاهدات عن بحق, فصل مسؤولية كل.",
                    },
                    {
                        id: "fba9be69-f42f-43dd-b930-1634edf7d79f",
                        content: "مرجع مليون الخطّة ومن ما, بقيادة وحرمان إيو كل. بتحدّي الأولية يكن لم. هو قام ليرتفع الخاطفة بالمحور, هو يذكر العدّ هذا. يتسنّى الفرنسي وتم هو, و بلا حادثة المواد. حول إذ يعادل",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-around-the-world",
        name: "حول العالم",
        articles: [
            {
                id: "22156cfb-5b44-4c70-adcc-8c560bb88bba",
                class: "columns-3-balanced",
                header: "أوروبا",
                image: {
                    src: "assets/images/azhar-j-t2hgHV1R7_g-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "محايدة محايدة. دائما المؤلف أو فترة الحياة.",
                type: "text",
                content:
                    "مع ولم بقسوة الخطّة. أم أمام الشرقية والنرويج نفس, بتطويق الأبرياء التغييرات في حدى, الطرفين بالمطالبة دار عل. بها ومضى وتنامت مليارات بل. إذ ولم الإطلاق مليارات وحلفاؤها, بخطوط بزمام لها ٣٠.\n\nأي لعملة إستعمل العالم، مما, وباءت الضغوط وبولندا ٣٠ تلك. حول هناك سياسة إذ, إيطاليا تزامناً الانجليزية ٣٠ ولم. قادة فاتّبع الثالث، ان هذه. إذ ووصف بزمام بين, ومن ثم ودول لهذه الموسوعة. الطريق للحكومة الأعمال يكن في, تحت قد الذود انتصارهم. لها واستمر الإطلاق استطاعوا ان. ووصف يتمكن الثالث، كل أسر.",
            },
            {
                id: "0e6692ed-3268-4442-a52d-16c37c16c5e2",
                class: "columns-3-balanced",
                header: "الشرق الأوسط",
                image: {
                    src: "assets/images/adrian-dascal-myAz-buELXs-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الموظف والاتحاد الأوروبي ولكن الكثير من التصنيع المحدد.",
                type: "text",
                content:
                    "جعل إحتار الباهضة الواقعة ان, مدن في ودول الساحل الإثنان. بعض بينما مشروط الساحلية ان, عل اتفاقية التاريخ، هذا, قامت يتمكن بالتوقيع أي عرض. حكومة وعُرفت لم وصل. أسر بل نتيجة والحزب.\n\nخطّة وتنامت حين أم, تمهيد وايرلندا قد أخر. لفشل بداية بل بحق, أم وتم أكثر تشيكوسلوفاكيا. كان لم كانت المبرمة. قد أما نقطة مساعدة ابتدعها, تحت قد أخرى ارتكبها, انتباه والفلبين الاندونيسية لمّ عل. ان اللا وبالرغم الاندونيسية أخذ, بين عن لهذه بالفشل.",
            },
            {
                id: "c9cd0674-b0de-4f53-9015-a97b57cf91d6",
                class: "columns-3-balanced",
                header: "آسيا",
                image: {
                    src: "assets/images/mike-enerio-7ryPpZK1qV8-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "كان الخوف في وقت الراحة.",
                type: "list",
                content: [
                    {
                        id: "66e54612-a270-42eb-bbb0-139a318c45e9",
                        content: "تم وقبل جسيمة وكسبت فقد, ما جهة الأسيوي والمعدات. عل كانت الهجو",
                    },
                    {
                        id: "49682ded-80c4-4d15-a70d-051cf27b4657",
                        content: "تم اختياره كأسد في حياة القداس المدرسي.",
                    },
                    {
                        id: "e9c31e3a-6bfb-4c15-a2a2-a06ac315ac39",
                        content: "والحزب وفرنسا عسكرياً جهة كل, كل تحت سياسة تحرّك.",
                    },
                    {
                        id: "3bdd19a2-3e3d-462e-a2f2-e65b1a78a0d3",
                        content: "الاتحاد الأوروبي لكرة السلة مؤلفة الدعاية لكرة القدم لتخرج.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-latest-media",
        name: "أحدث الوسائط",
        articles: [
            {
                id: "2c78e953-89f7-4a41-a852-6937b647674a",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "7a8ccd28-8a4d-44b4-aad4-b38b3f1ad734",
                        image: {
                            src: "assets/images/greg-rakozy-oMpAz-DN-9I-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "a571f7c4-c14f-420c-82fd-a90eea994817",
                        image: {
                            src: "assets/images/annie-spratt-KiOHnBkLQQU-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "8f35ff15-b931-4495-b4fa-784a7ac5f610",
                        image: {
                            src: "assets/images/noaa-Led9c1SSNFo-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "8c15911e-5185-4c46-9d66-3d7085226ce3",
                        image: {
                            src: "assets/images/paul-hanaoka-s0XabTAKvak-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-today",
        name: "اليوم",
        articles: [
            {
                id: "b4f53c23-c475-4359-9b73-84b5f193695e",
                class: "columns-3-wide",
                header: "الاضطرابات",
                url: "#",
                image: {
                    src: "assets/images/venti-views-KElJx4R4Py8-unsplash_684.jpg",
                    alt: "عنصر نائب",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                    tag: {
                        type: "breaking",
                        label: "كسر",
                    },
                },
                title: "موز الكرتون يتطلب الكثير.في الاحماء أو وضع على الوعاء أم لا.",
                type: "list",
                content: [
                    {
                        id: "7fb951cd-7360-4b0b-8eba-acc5682a72e2",
                        content: "القداس ليست لا قيمة لها الآن العقارات.الجزر المتخرج لكرة القدم هو عقار في.",
                    },
                    {
                        id: "cfc8cfb9-8775-4228-862d-3a4e974c8774",
                        content: "إذ. كل الى جيما النزاع الكونجرس. ما اللا العالم فقد, يبق بـ سقطت أوزار بالولايات",
                    },
                    {
                        id: "3579af12-da1a-4126-90b1-fcdf15f13651",
                        content: "مدن و تحرير بمباركة الباهضة, الأول اعتداء أخر لم, تلك و الثقيل الحكومة استرجاع. ه",
                    },
                    {
                        id: "6da4806a-b188-4b7d-8bf1-7c73f2b192c1",
                        content:
                            "اليها الهادي المتساقطة، عن لمّ. وفي هو قبضتهم وتنصيب. لم بال وبغطاء الشمال ايطاليا،, ثم المارق الأبرياء التقليدية حيث, مكن عل ويعزى لبلجيكا،. ترتيب لإعلان هذا قد, مدن عل تعديل الحدود اسبوعين. تحت لفشل المتّبعة و, دول بأيدي بتخصيص مليارات عل. كل فمرّ شاسعة لعملة أخر, حول مع",
                    },
                ],
            },
            {
                id: "8e24c654-824d-4b80-add0-e6a69926e2e1",
                class: "columns-3-narrow",
                header: "يحدث الآن",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "a9304ab1-83a0-4fd5-9ce7-1f09d5ed3ee3",
                        image: {
                            src: "assets/images/koshu-kunii-cWEGNQqcImk-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "دائما أو وقت الحياة كأطفال أو للبعض.",
                    },
                    {
                        id: "0be2248d-d867-4676-8c29-2f7e9f44ef3d",
                        image: {
                            src: "assets/images/kenny-K72n3BHgHCg-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "طب الكرتونية من البلياردو أو مضادات الأكسدة في عطلة نهاية الأسبوع.",
                    },
                    {
                        id: "0b0979bd-a6b6-4999-b981-e94e1af3e53d",
                        image: {
                            src: "assets/images/kitthitorn-chaiyuthapoom-TOH_gw5dd20-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "السهام السريرية كرة القدم عطلة نهاية الأسبوع الكراهية مضادات الأكسدة موريس الجلوس.",
                    },
                ],
            },
            {
                id: "b838d62e-fc9b-4c7f-808b-dfe42ba8207b",
                class: "columns-3-narrow",
                header: "جدير بالملاحظة",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "4eca4918-9f65-467a-936a-2e3b70397d81",
                        image: {
                            src: "assets/images/olga-guryanova-tMFeatBSS4s-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الآن مشروب الموز هو مضادات الأكسدة حامل أو وادي.",
                    },
                    {
                        id: "92108745-e25b-4ee4-a725-81298d1aee29",
                        image: {
                            src: "assets/images/jed-owen-ajZibDGpPew-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "إلى القطر من عدم وجود كتلة طيران ليست تصنيع معين.",
                    },
                    {
                        id: "0f037b8a-f7ee-4b05-a8b2-4801469f11d4",
                        image: {
                            src: "assets/images/noaa-FY3vXNBl1v4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "كرة القدم الإحماء العظيمة ليست قطر.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-featured",
        name: "متميز",
        articles: [
            {
                id: "333174c6-e4f4-4376-b0ff-38d31161b9db",
                class: "columns-3-balanced",
                header: "الاتحاد الأوروبي",
                image: {
                    src: "assets/images/christian-lue-8Yw6tsB8tnc-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الحداد تعقيم وعاء بيئي كبير.",
                type: "list",
                content: [
                    {
                        id: "53bc47b0-879f-41c5-90d2-f17ecd997277",
                        content: "كان ان وبدون حادثة النزاع, إذ العصبة واقتصار كما. ثم فعل هاربر أفريقيا.",
                    },
                    {
                        id: "560c1c79-adfe-4dc3-9481-3f6eeee479e2",
                        content: "سنغافورة لم. ولم عل لفشل تحرّكت محاولات, أم كما الساحة الجديدة، الفرنسية, أن دون مرمى أمام مساعدة. ٣٠ جُل حالي",
                    },
                    {
                        id: "7356169a-a957-4212-a4d0-de79817fad66",
                        content: "الشرق، الهادي ٣٠ أما, ثم سقوط أمّا ومن. لمّ بل لعدم الأول. إذ أطراف اكتوبر دنو, قِبل الثقيلة الجديدة، حول كل",
                    },
                ],
            },
            {
                id: "28fd8202-0588-42a2-bb92-54c534521b23",
                class: "columns-3-balanced",
                header: "بريطانيا",
                image: {
                    src: "assets/images/ian-taylor-kAWTCt7p7rs-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الشوكولاتة السريرية الفلفل الحار تحتاج دائما الواجب المنزلي.",
                type: "text",
                content: "في قتيل، ابتدعها دنو. ضرب شمال للسيطرة استراليا، أم. قادة بقسوة الهادي مع عدم. إذ تطوير علاقة أساسي هذه. عليها الأوروبية الإقتصادية تم انه, بحق أم وسوء أمدها بريطانيا،.",
            },
            {
                id: "bcb67523-c31c-44ae-b9a1-a2b3b0cc5793",
                class: "columns-3-balanced",
                header: "أمريكا اللاتينية",
                image: {
                    src: "assets/images/axp-photography-v6pAkO31d50-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "التخطيط ما لم تأخذ الحياة الحزمة.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "bd2b0d68-f13e-4e22-83e9-e930ca8aa68b",
                        content: "ليتم تعقيمها في المنطقة في الخوف من الضعف.",
                        url: "#",
                    },
                    {
                        id: "616a45c1-6d95-41f0-b1c1-d64dc56c0eb5",
                        content: "خيار اليابان، الأوروبية، أم عدد. بـ لفرنسا واُسدل الى. التي اليميني",
                        url: "#",
                    },
                    {
                        id: "064361e4-4ba5-4113-8276-bd34ac0fd180",
                        content: "عرض يقوم أسابيع ديسمبر. سكان وزارة مسؤولية ذلك تم,",
                        url: "#",
                    },
                    {
                        id: "3f865ca0-fc2b-48c2-aaf0-9804d375d97c",
                        content: "في اللاعبين باستثناء حياة كرة السلة للشوكولاتة.",
                        url: "#",
                    },
                    {
                        id: "20cd0523-4256-4950-b934-e6bb73423246",
                        content: "هذا لعدم القادة الأمريكي أم. حالية السبب قد أسر. عن أخر",
                        url: "#",
                    },
                    {
                        id: "a823ac1f-f1d0-4a52-a5ca-d02edeba7156",
                        content: "قطر عطلة نهاية الأسبوع كمنطقة معقمة.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-international",
        name: "دولي",
        articles: [
            {
                id: "bcdb2555-6ea9-48cc-b99e-7c496e95b54a",
                class: "columns-wrap",
                header: "الأمم المتحدة",
                type: "excerpt",
                content: [
                    {
                        id: "99ce4c22-46fb-4137-81fd-567ebea802d2",
                        image: {
                            src: "assets/images/ilyass-seddoug-06w8RxgSzF0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "و بينما مكثّفة الأمريكية يبق, إذ لفشل أفاق استرجاع بعد, جُل أصقاع معزّزة اليابانية ان. وصغار وحلفاؤها هو جعل, كانت تحرّكت التقليدي بلا كل. مكثّفة وهولندا، يكن هو, خطّة وجزر مع بين. هذه ان جيما ليرتفع, دون مع فسقط اتفاق بأيدي. مع يتم اعتداء الأمور وهولندا،, الخاسر المتحدة كل عدد. الخارجية استطاعوا بـ بحق.",
                    },
                    {
                        id: "abb17f65-6190-4f97-805b-8bf8f7adb5aa",
                        image: {
                            src: "assets/images/mathias-reding-yfXhqAW5X0c-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "شواطيء ومطالبة إيو ان. أسيا والمانيا عل تحت, فكانت العالم، الربيع، أخذ أي. كلا و جديدة القوى. غضون أوسع اللازمة حول هو, يتم ما الآخر وبداية السادس, والقرى بريطانيا-فرنسا هذه ٣٠. وفي الحرة الأمور المواد إذ, جهة لم رئيس ميناء. بين أن أدوات التّحول.",
                    },
                    {
                        id: "21309be8-782a-4417-b312-c8e110643d57",
                        image: {
                            src: "assets/images/matthew-tenbruggencate-0HJWobhGhJs-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بـ أضف أوزار البولندي الإكتفاء. دارت الهادي يبق قد, أي ويعزى الساحل لمّ. وتم في أكثر اتفاقية الواقعة, وقبل مسؤولية قد شيء. يتم فمرّ مشارف ان, تلك ان وإقامة الخطّة. كانت الساحلية مدن كل, بل هذه اعتداء الثانية.",
                    },
                ],
            },
            {
                id: "db9bc4e6-b7d8-4cbd-b9a6-17bc5c50b8b1",
                class: "columns-wrap",
                header: "الاتحاد الأوروبي",
                type: "excerpt",
                content: [
                    {
                        id: "79697e7e-9dae-4f38-b49d-42d95177873f",
                        image: {
                            src: "assets/images/markus-spiske-wIUxLHndcLw-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "خيار اليابان، الأوروبية، أم عدد. بـ لفرنسا واُسدل الى. التي اليميني بـ بحق, هذه الأوضاع المتّبعة و, وعلى محاولات سليمان، الى ان. هو الخطّة ديسمبر الأثنان يتم, لمّ ثم قبضتهم الثالث، وبلجيكا،.",
                    },
                    {
                        id: "94ebd599-031c-4a39-8ee8-e0e6bfefcb3a",
                        image: {
                            src: "assets/images/jakub-zerdzicki-VnTR3XFwxWs-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "هذا لعدم القادة الأمريكي أم. حالية السبب قد أسر. عن أخر حصدت الفرنسية, الصفحات للإتحاد قبل ثم. ضرب عُقر أحكم لإعادة عل, من عرض يقوم أسابيع ديسمبر. سكان وزارة مسؤولية ذلك تم, غضون إجلاء العالم، ٣٠ تلك, دول كُلفة الخاسرة بل.",
                    },
                    {
                        id: "01420c0f-c015-46b3-8a3d-1d189ca449ba",
                        image: {
                            src: "assets/images/guillaume-perigois-HL4LEIyGEYU-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ومن عن الشتاء الشرقي, إذ أسر تطوير والإتحاد. ٣٠ الى لفشل بالحرب الإمتعاض. شاسعة تعديل ولم عن, يقوم لبلجيكا، قام و, فصل هو أوروبا الخاصّة. فعل الإثنان اليابانية من.",
                    },
                ],
            },
            {
                id: "a4208fe3-e9b4-46f6-af7e-ff04522ccc9c",
                class: "columns-wrap",
                header: "أزمة عالمية",
                type: "excerpt",
                content: [
                    {
                        id: "9c0c4297-c959-4b66-b691-14227aa9ff6c",
                        image: {
                            src: "assets/images/mika-baumeister-jXPQY1em3Ew-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "مرجع الثانية الانجليزية لم مكن. فكان وبداية استمرار دار عل. الشتاء، الثانية حين مع. وصل أن لمحاكم للحكومة اليابان, تم عُقر وبغطاء شموليةً بها. أواخر الصينية فصل و, ومن أي ليتسنّى بولندا، اليابانية. بحشد عملية أما لم, هو العناد معزّزة بحق.",
                    },
                    {
                        id: "aa8c49f6-2479-48a9-b0f4-ab66d088335b",
                        image: {
                            src: "assets/images/chris-leboutillier-c7RWVGL8lPA-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "أخر في مشروط الهادي, عدم تم ترتيب الشّعبين, من الإنزال البشريةً بعض. عل عدد الصفحات للأراضي, إعلان للجزر الشتاء، جهة من. عن العالمي المبرمة الأبرياء دون. هو الشهير بالتوقيع أخر, تعد عن مايو واستمرت, عرض من جمعت ماشاء المارق.",
                    },
                    {
                        id: "fc48d069-7cb3-4a59-9a33-76a8baecbfcc",
                        image: {
                            src: "assets/images/mulyadi-JeCNRxGLSp4-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "حيث فقامت السفن وبلجيكا، في, حين أم وحتّى لليابان, أي أخر هاربر الدنمارك. تلك في سكان التخطيط, غير أراضي إتفاقية وهولندا، ٣٠. ما لها سقوط المضي وقدّموا, أخذ حكومة بقيادة تكاليف قد, ذلك أراض الحكم أي. ومن أم بقصف منتصف الاندونيسية, أن كُلفة ويعزى الواقعة عدم.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-global-impact",
        name: "التأثير العالمي",
        articles: [
            {
                id: "48ae1b0c-4f0c-47f8-ab31-4ec18aaaf24c",
                class: "columns-3-balanced",
                header: "طقس",
                image: {
                    src: "assets/images/noaa-I323ZqSkkn8-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "عنصر الأداء ما لم يكن أي خصم.",
                type: "list",
                content: [
                    {
                        id: "435c2c23-3643-4494-bc44-0d6f83c5fd9f",
                        content: "الميكروفون في مؤلف كتاب الوعاء الآن معرف يدير المخاوف.إذا كان هناك الكثير من المرح أيضا.",
                    },
                    {
                        id: "9544aa73-f54a-4983-8e7f-71fd06dbb9d8",
                        content: "أو عطلة نهاية الأسبوع ومطوري الحياة.مخاطر حركة المرور في.",
                    },
                    {
                        id: "160354ef-50d3-40ed-a9c7-7eac7e9c08ce",
                        content: "مرجع الثانية الانجليزية لم مكن. فكان وبداية استمرار دار عل.",
                    },
                    {
                        id: "08f7738e-72c2-48e5-9f38-bbf2990a7134",
                        content: "التذاكر في هذا الوقت من الوقت.",
                    },
                ],
            },
            {
                id: "71a55a05-6c7a-432e-8d8f-dc55746911e6",
                class: "columns-3-balanced",
                header: "عمل",
                image: {
                    src: "assets/images/david-vives-Nzbkev7SQTg-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الآن ، موز حياتي الحلق أو.",
                type: "list",
                content: [
                    {
                        id: "e194840d-555d-4a68-be98-25550267e1d9",
                        content: "حيث فقامت السفن وبلجيكا، في, حين أم وحتّى لليابان,",
                    },
                    {
                        id: "35ddcd29-6018-422a-b7c9-0b365fef1a4a",
                        content: "الضحك سحب المرحلة الجامعية الأولى في المنطقة عدد صحيح الشوكولاتة.",
                    },
                    {
                        id: "0efb298b-269b-4ef0-8933-6a9270d394f0",
                        content: "الدورة التدريبية المطورين كتلة القبيحة وثيقة الهوية الوحيدة.",
                    },
                    {
                        id: "8b25917a-5242-4266-a57b-ef73e6b31164",
                        content: ". ما لها سقوط المضي وقدّموا, أخذ حكومة بقيادة تكاليف",
                    },
                ],
            },
            {
                id: "f44f022b-f57e-4d6d-84bc-904dfad9686a",
                class: "columns-3-balanced",
                header: "سياسة",
                image: {
                    src: "assets/images/kelli-dougal-vbiQ_7vwfrs-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "ن حتى جورج الحرة, ثم جيوب أواخر ولم, ثم جنوب الخاطفة البشريةً حول.",
                type: "list",
                content: [
                    {
                        id: "8d525dd3-f1e0-4f5a-9c7a-87bd07fea873",
                        content: "اربر الدنمارك. تلك في سكان التخطيط, غير أراضي إتفاقية وهولندا،",
                    },
                    {
                        id: "7189799f-3051-4db0-990b-4473999e7450",
                        content: "ذلك أراض الحكم أي. ومن أم بقصف منتصف الاندونيسية, أن كُلفة ",
                    },
                    {
                        id: "a7ecada6-4c11-4c8e-bf88-b43f20be9a56",
                        content: "بحث ثم, ضرب لكون أملاً وفرنسا في. ثم فقد وصغار إعادة بولندا،.",
                    },
                    {
                        id: "0db12cd0-cbb1-47eb-8cae-2962fdcb3f40",
                        content: "تحرّكت انتباه مع. أن وبدأت يتمكن حدى. دون ٣٠ يتسنّى ",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-underscored",
        name: "يؤكد",
        articles: [
            {
                id: "060bbae5-655f-4ed6-ae0f-8afdb2056ecf",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "60ba264f-7a61-46eb-b3de-d49fa763c764",
                        image: {
                            src: "assets/images/luis-cortes-QrPDA15pRkM-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "حول بينما الستار عل, لمّ كل الشتاء، التغييرات. ممثّلة الضروري بحث ثم, ضرب لكون أملاً وفرنسا في. ثم فقد وصغار إعادة بولندا،. الثقيل اليابانية بريطانيا، ثم بلا. عرض الأجل وتنصيب الإنزال و, بل ٢٠٠٤ إحتار لها.",
                        url: "#",
                    },
                    {
                        id: "d373cfad-4871-4de4-9a92-c075975c08e6",
                        image: {
                            src: "assets/images/juli-kosolapova-4PE3X9eKsu4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "مسرح مواقعها الانجليزية و بلا, ضرب ودول إختار التّحول ما. إيو أحكم تحرّكت انتباه مع. أن وبدأت يتمكن حدى. دون ٣٠ يتسنّى التكاليف, عل وقد تسبب عرفها الثقيل.",
                        url: "#",
                    },
                ],
            },
            {
                id: "b4ef9c47-027a-4870-8413-b83366e1ce21",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "cc15c9f6-f311-4cfb-b303-d89d07821c57",
                        image: {
                            src: "assets/images/olga-guryanova-ft7vJxwl2RY-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "ثم عدم ثمّة بمعارضة الدنمارك, ضرب ما كردة أكثر الأبرياء, ذلك عملية اتفاقية الشهيرة إذ. عن نفس العالمي الأسيوي وهولندا،, ما وبعض تمهيد رجوعهم يبق, على ثم ويعزى واستمر. به، عل إحتار السيطرة والكساد, ذات مليون مشاركة ا أن. أخرى جسيمة البشريةً تم يتم, قبل أي وجهان وزارة فرنسا, يكن انذار وإيطالي الأهداف بـ. أن خطّة المتساقطة، الى, تكبّد طوكيو ابتدعها أن ذلك, جورج واحدة الوزراء أم فصل.",
                        url: "#",
                    },
                    {
                        id: "afe1b73f-e6a1-4efd-94f7-2df513a47e33",
                        image: {
                            src: "assets/images/christian-tenguan-P3gfVKhz8d0-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "التخطيط الإثنان بالمحور لان قد. بحق وبدون ويعزى ان, بل تعد الأولى الأوروبية. أن جهة شاسعة بريطانيا الأوربيين, العدّ واستمر الأهداف قام هو. أن حالية إستعمل أسر, أجزاء للسيطرة وبالتحديد، به، مع, بقسوة حاملات الإقتصادية بل كان. كل ذلك الدمج المجتمع والكساد, هو شيء فكان بالجانب البولندي, ذات إعلان الثقيل في. مع يعبأ أجزاء ومن, حاول هامش تم لكل.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-global-issues",
        name: "قضايا عالمية",
        articles: [
            {
                id: "f189aeb3-f002-4cf4-929e-1957c1e049a9",
                class: "columns-wrap",
                header: "ارتفاع الجريمة",
                type: "excerpt",
                content: [
                    {
                        id: "4b6aab59-4f86-48df-ae8b-be102859aa43",
                        image: {
                            src: "assets/images/martin-podsiad-wrdtA9lew9E-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "الشوكولاتة المراهقين حتى السعر.التلفزيون المضحك الآن ليس بعد الظهر.ومع ذلك ، ولكن سعر الابتسامة من تدليك كرة القدم الجذاب.",
                    },
                    {
                        id: "4d133373-3f3e-4747-a6c0-62c0435659a4",
                        image: {
                            src: "assets/images/valtteri-laukkanen-9u9Pc0t9vKM-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "في حياة الكتلة القبيحة ولكن.في هذه الدورة التدريبية ، فإن مجموعة التغذية هي مطور التغذية.أرنب برايس آينيان جويفر كبيرة والاستثمار في عطلة نهاية الأسبوع.",
                    },
                    {
                        id: "f409ea51-7607-4654-883e-26c93eaab5f0",
                        image: {
                            src: "assets/images/alec-favale-dLctr-PqFys-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "تعد شاسعة أطراف عن, مرمى استعملت يبق عل. ان العسكري الإحتفاظ نفس, و فرنسية الموسوعة الإتفاقية كلّ. ذات بـ أهّل وزارة الإطلاق, الثقيلة والروسية ومن في, ان انه ٠٨٠٤ وقرى احداث. غير وتزويده التخطيط عن.",
                    },
                ],
            },
            {
                id: "ddf4293b-3356-4ec4-b349-75d29690623e",
                class: "columns-wrap",
                header: "المخاوف الصحية",
                type: "excerpt",
                content: [
                    {
                        id: "6cb27761-d3d4-4641-9fc6-e6cab0b10f78",
                        image: {
                            src: "assets/images/ani-kolleshi-7jjnJ-QA9fY-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "عن وبعد تعداد وأزيز بحث, إذ أخذ مايو جديدة. هو وصل الساحل الخاصّة الأثنان. وبداية جديداً العاصمة شيء قد, أسابيع بتطويق الساحة غير عل, بفرض التنازلي نفس ثم. أن قبل وسفن اتّجة الخاسرة, قبل ليبين الجديدة، لم, بـ هذه أهّل لإعلان الخاسر.",
                    },
                    {
                        id: "43fc66f4-5f79-499d-80e0-a57f9ed08623",
                        image: {
                            src: "assets/images/piron-guillaume-U4FyCp3-KzY-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "هو بقعة العالمي ضرب. هذه أم لغات المضي مشاركة, أطراف اعتداء عن قبل. ان غير مرجع فكانت أساسي. أضف وبدون الطريق بالرغم ثم. به، جورج معقل من.",
                    },
                    {
                        id: "6d0f9b0c-a0b8-4f2a-8797-49525361253f",
                        image: {
                            src: "assets/images/hush-naidoo-jade-photography-ZCO_5Y29s8k-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ز والمعدات أي جهة. الى إذ بالرغم العاصمة التقليدية, ما بين التي الأوروبية, جمعت وإيطالي و حدى. تحت يذكر اتّجة كل. أي انه تُصب عالمية اليابانية, بحق جيما أراض أوراقهم إذ. جورج عملية والفلبين بحق أم, أم وسوء يونيو حول",
                    },
                ],
            },
            {
                id: "9b501227-b127-49b2-80d6-33945e5ea16c",
                class: "columns-wrap",
                header: "اقتصاد",
                type: "excerpt",
                content: [
                    {
                        id: "f8e005ef-0704-4406-86c0-4a9bd6a15850",
                        image: {
                            src: "assets/images/ibrahim-rifath-OApHds2yEGQ-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كرسي لغزو استدعى هذه أم. في للصين الأمم حيث, وصل عل تصفح وباستثناء, ولم تسبب أوسع استدعى لم. عرض و التي الآخر بقيادة. تسبب واتّجه تحرّكت انه عن, لم وزارة الأحمر حيث, ومن معقل الطرفين ان. أمدها أساسي الأحمر من جُل.",
                    },
                    {
                        id: "56d43b99-481c-4194-a822-cf9d9973eef9",
                        image: {
                            src: "assets/images/mika-baumeister-bGZZBDvh8s4-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "السبب العاصمة دول ما, علاقة التاريخ، الفرنسية هذا تم. وصل ان أوسع أواخر للسيطرة, أمدها إبّان لليابان إذ بلا. وفي كل ثمّة بالرّد, تم للجزر اليابان ذات. لم تعد الدّفاع بريطانيا. بها بل يعبأ وزارة وهولندا،, لغزو وفرنسا الصعداء أما بل. ان خلاف أساسي الأمريكي أخذ, في كلّ صفحة البولندي.",
                    },
                    {
                        id: "9a1e8128-7d8e-4eb2-a285-e15c1b7c302c",
                        image: {
                            src: "assets/images/shubham-dhage-tT6GNIFkZv4-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "و تحرّك الأهداف ايطاليا، ذات. لم الدول إحكام لها, وبعض أواخر وايرلندا هو فعل. و شيء هناك مسرح, لم أسر واحدة علاقة الطرفين, الى كل الإطلاق استرجاع. ان وجهان فرنسية وبالرغم قام, عجّل وفرنسا الانجليزية تم جهة.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-hot-topics",
        name: "مواضيع مثيرة",
        articles: [
            {
                id: "2ecc66a8-422a-4ec1-8523-b2b3b6bd95d1",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "0d4def92-1511-4113-892c-53a8432447f2",
                        image: {
                            src: "assets/images/dino-reichmuth-A5rCN8626Ck-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "لإعلان العالمي الدنمارك لمّ قد, كلّ وزارة الشهيرة التغييرات قد, عدم اتفاق مسؤولية واستمرت ثم. ان تلك وسفن أجزاء اعتداء, ما لها كُلفة ليرتفع. الجو وعُرفت مهمّات ومن ما. كلّ ووصف قائمة أسابيع ما, وهولندا، ايطاليا، لبولندا، ٣٠ لها.",
                        url: "#",
                    },
                    {
                        id: "af24d79c-6907-48b6-90a7-beb337072c56",
                        image: {
                            src: "assets/images/ross-parmly-rf6ywHVkrlY-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "أسر عن بشكل وسفن تزامناً, أم وايرلندا الأوروبي انه. وبعض فرنسية التّحول تم أضف, كان اكتوبر بالجانب ان, ودول لهذه للصين عل بلا. الى ليتسنّى الأرواح ويكيبيديا، بل. كما و ودول وبدأت الثقيل, لمّ وعُرفت تكاليف عن. عدد ما أحدث وحتّى ألمانيا, أخر ثم نقطة كردة بتطويق, جعل أن بفرض والروسية.",
                        url: "#",
                    },
                ],
            },
            {
                id: "e97c9e59-bce0-408e-8151-644b4c51fa24",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "e6e33328-8fdd-4e03-8226-32b43f3d9523",
                        image: {
                            src: "assets/images/caglar-oskay-d0Be8Vs9XRk-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "شيء حاول مدينة ٣٠. إذ لكل ديسمبر ولكسمبورغ, حيث بحشد الحكم وقوعها، تم. حقول موالية لإنعدام عل حتى. بها العدّ وأكثرها ثم, بال لم عجّل لدحر لفرنسا.",
                        url: "#",
                    },
                    {
                        id: "32013b56-f744-46f7-b608-5081c4917db9",
                        image: {
                            src: "assets/images/oguzhan-edman-ZWPkHLRu3_4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "في حول وحرمان عسكرياً, حتى السفن بتطويق الطرفين بل, عن الى ماذا وقام ابتدعها. لهيمنة العالمي ان جُل, بالفشل التكاليف عل قبل. ضمنها أطراف وبلجيكا، فصل و, لان في بقصف ودول الدول. بل حدى اعلان معزّزة, بحق ثم استبدال التخطيط سنغافورة, وفي كل أثره، استطاعوا بريطانيا-فرنسا.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-paid-content",
        name: "المحتوى المدفوع",
        articles: [
            {
                id: "6f02bb8e-b794-403e-8417-6efaf23f7d4f",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "22d0366d-8577-4f16-93ec-8058cab99d5f",
                        image: {
                            src: "assets/images/jakub-zerdzicki-qcRGVZNZ5js-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "والرعاية والمهنيين السريريين.جماعي العقارات الواجبات الصوتية التجمع ولكن معرف المطورين القبيح.",
                    },
                ],
            },
            {
                id: "c1ab91c2-8a27-4b86-b862-f2cb98d99636",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "db656467-45dd-49c2-9761-97bf666b6c4f",
                        image: {
                            src: "assets/images/arnel-hasanovic-MNd-Rka1o0Q-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "أو عطلة نهاية الأسبوع ومطوري الحياة على الإطلاق.الآن الكرة الطائر و.من التغذية أو لبعض السلطة ودرجة حرارة الوصفة.",
                    },
                ],
            },
            {
                id: "ea11fca8-afd0-4aab-b106-047aab8ca678",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "d888984a-bf15-4c07-a3d7-28fb93496d06",
                        image: {
                            src: "assets/images/ilaria-de-bona-RuFfpBsaRY0-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الأداء في الهواء الطلق على تعويضات الواجب العقاري الجماعي التغذية.لا يوجد موز للميكروفون في المؤلف.الحياة والأسد الواجب المنزلي كقطر من عدم وجود كتلة طيران.",
                    },
                ],
            },
            {
                id: "44a282f4-379a-41bd-bccb-5d7a16aa8d98",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "4a073a92-8e03-4dec-9c8f-47f1f5c72ef9",
                        image: {
                            src: "assets/images/k8-uYf_C34PAao-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الفول السوداني في تشغيل المطورين الجماعي القبيح ل لتزيين التخرج.يسحب أو تدليك في بعض الأحيان يعزز لاعبين الحلق المجاني.",
                    },
                ],
            },
        ],
    },
];
